import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import logo from '../../assets/SenritsuXwordmarkwhite.png';
import '../../styles/Home.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-top-grid">
          {/* Brand column */}
          <div className="footer-brand-col">
            <Link to="/" className="footer-brand-logo-link">
              <img src={logo} alt="SenritsuX" className="footer-logo-img" />
            </Link>
            <p className="footer-brand-desc">
              <span className="brand-font">SenritsuX</span> is an independent music distribution and artist services platform helping artists distribute music, manage releases, build their artist presence, and grow their creative career.
            </p>
          </div>

          {/* Ecosystem Column */}
          <div className="footer-links-col">
            <h4 className="footer-col-title">Ecosystem</h4>
            <ul className="footer-nav-list">
              <li><Link to="/" className="footer-link">Home</Link></li>
              <li><Link to="/services" className="footer-link">Services &amp; Pricing</Link></li>
              <li><Link to="/artists" className="footer-link">Artist WEB</Link></li>
              <li><Link to="/about" className="footer-link">About <span className="brand-font">SenritsuX</span></Link></li>
              <li><Link to="/faq" className="footer-link">FAQ</Link></li>
              <li><Link to="/contact" className="footer-link">Contact Support</Link></li>
            </ul>
          </div>


          {/* Creators Column */}
          <div className="footer-links-col">
            <h4 className="footer-col-title">Creators</h4>
            <ul className="footer-nav-list">
              <li><Link to="/signup" className="footer-link">Join <span className="brand-font">SenritsuX</span></Link></li>
              <li><Link to="/login" className="footer-link">Artist Login</Link></li>
              <li>
                <Link to="/distribution?mode=new" className="footer-link">
                  Music Distribution <ArrowUpRight size={13} style={{ display: 'inline-block', verticalAlign: 'middle' }} />
                </Link>
              </li>
              <li>
                <a
                  href="https://wa.me/916386568997"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  WhatsApp Direct <ArrowUpRight size={13} style={{ display: 'inline-block', verticalAlign: 'middle' }} />
                </a>
              </li>
            </ul>
          </div>

          {/* Social Links Column */}
          <div className="footer-links-col">
            <h4 className="footer-col-title">Connect</h4>
            <div className="footer-social-vertical">
              <a
                href="https://www.instagram.com/senritsux.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-badge"
                aria-label="Instagram"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                </svg>
                <span>Instagram</span>
              </a>

              <a
                href="https://www.youtube.com/channel/UCc-rHhzIWQhebDyPC2Vjf5g"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-badge"
                aria-label="YouTube"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z" />
                  <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" />
                </svg>
                <span>YouTube</span>
              </a>

              <a
                href="https://wa.me/916386568997"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-badge"
                aria-label="WhatsApp"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                </svg>
                <span>WhatsApp</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="footer-copyright" style={{ textAlign: 'center' }}>
          <p style={{ margin: 0 }}>© 2026 <span className="brand-font">SenritsuX</span>. All rights reserved. Music distribution and artist services for independent artists.</p>
        </div>
      </div>
    </footer>
  );
}
